module.exports = __webpack_public_path__ + "img/project-innerpage-2.jpg?944ef56d8bd8e004e1fa4c1cca3c0cd8";